import React from "react"
import ReactDOM from "react-dom"
import EnvironmentStore from "@geome/sdk/lib/app/store/environment"
import LayoutStore from "@geome/shell-locator-components/lib/stores/layout"
import LayoutToggleWindowCommand from "@geome/shell-locator-components/lib/commands/view/layout/toggleWindow"
import SelectLocationCommand from "@geome/shell-locator-components/lib/commands/view/locations/select"
import SelectDistanceUnitCommand from "@geome/shell-locator-components/lib/commands/view/settings/selectDistanceUnit"
import SetLocaleCommand from "@geome/shell-locator-components/lib/commands/view/routing/setLocale"
import Config from "./config"
import AppComponent from "./components/app"
import HttpClient from "./api/adaptor/httpClient"
import LibActionTypesValue from "@geome/shell-locator-components/lib/values/actionTypes"
import ActionTypesValue from "./values/actionTypes"
import Inject from "@geome/inject"

import FluxBasicsFeature from "@geome/sdk/lib/app/feature/flux/basics"
import FluxConfigFeature from "@geome/sdk/lib/app/feature/flux/config"
import FluxDirectionsFeature from "@geome/sdk/lib/app/feature/flux/directions"
import FluxFiltersFeature from "@geome/sdk/lib/app/feature/flux/filters"
import FluxGeolocationFeature from "@geome/sdk/lib/app/feature/flux/geolocation"
import FluxMapFeature from "@geome/sdk/lib/app/feature/flux/map"
import FluxRoutingFeature from "@geome/sdk/lib/app/feature/flux/routing"
import FluxSearchFeature from "@geome/sdk/lib/app/feature/flux/search"
import GoogleSearchFeature from "@geome/sdk/lib/app/feature/google/search"
import ResourceCompletionFeature from "@geome/sdk/lib/app/feature/resource/completion"
import ResourceFindFeature from "@geome/sdk/lib/app/feature/resource/find"
import SearchFeature from "@geome/sdk/lib/app/feature/search"
import SearchRoutingFeature from "@geome/sdk/lib/app/feature/search/routing"

const { inject, feature, resolve, register, initializer, start } = Inject()

feature({
  FluxBasicsFeature,
  FluxConfigFeature,
  FluxDirectionsFeature,
  FluxFiltersFeature,
  FluxGeolocationFeature,
  FluxMapFeature,
  FluxRoutingFeature,
  FluxSearchFeature,
  GoogleSearchFeature,
  ResourceCompletionFeature,
  ResourceFindFeature,
  SearchFeature,
  SearchRoutingFeature,
})

register("registry::flux::commands", {
  "layout.toggleWindow"() {
    return {
      class: LayoutToggleWindowCommand,
    }
  },
  "locations.select"() {
    return {
      class: SelectLocationCommand,
      deps: {
        placeFinderUtil: resolve("util::place::finder"),
        window,
      },
    }
  },
  "routing.setLocale"() {
    return {
      class: SetLocaleCommand,
      deps: {
        document,
      },
    }
  },
  "settings.selectDistanceUnit"() {
    return {
      class: SelectDistanceUnitCommand,
      deps: {
        gApi: resolve("gApi"),
      },
    }
  },
})

register("registry::routes", {
  "/"() {
    return {
      match: ["/"],
      component: AppComponent,
    }
  },
})

register("registry::resources", {
  locations() {
    return {
      views: {
        bounded: {
          type: "bounded",
          coalesceViews: {
            radial: [
              "open_status",
              "tz_offset",
              "opening_hours",
              "fuel_pricing",
              "driving_distance",
              "driving_duration",
              "next_open_status_change",
            ],
            singleton: [
              "open_status",
              "tz_offset",
              "opening_hours",
              "fuel_pricing",
              "driving_distance",
              "driving_duration",
              "next_open_status_change",
            ],
          },
        },
        radial: {
          type: "radial",
          coalesceViews: {
            singleton: ["opening_hours", "fuel_pricing", "driving_distance", "driving_duration"],
          },
        },
        singleton: {
          type: "singleton",
        },
      },
    }
  },
})

inject("httpClient", () => new HttpClient())

register("registry::flux::actionTypes", LibActionTypesValue.concat(ActionTypesValue))

register("registry::flux::stores", {
  environment() {
    return { class: EnvironmentStore }
  },
  layout() {
    return { class: LayoutStore }
  },
})

initializer("App", () => render(AppComponent))

const getAppProps = () => ({
  get: () => {},
  i18n: resolve("i18n"),
  commandHandler: resolve("flux::commandHandler"),
  queryHandler: resolve("flux::queryHandler"),
  routingHistory: resolve("routing::history"),
  routingRegistry: resolve("routing::registry"),
  mapFactory: resolve("map::factory"),
  routerProps: {
    routes: resolve("routing::registry").getComponentRoutes(),
    history: resolve("routing::history"),
  },
})

const render = (Component) => {
  ReactDOM.render(<Component {...getAppProps()} />, document.getElementById("app"))
}

document.addEventListener("DOMContentLoaded", () => start(Config))
